import { createAction } from 'redux-actions';

export const MY_BALANCE = 'MY_BALANCE';
export const myBalance = createAction(MY_BALANCE);

export const UPDATE_BALANCE = 'UPDATE_BALANCE';
export const updateBalance = createAction(UPDATE_BALANCE);

export const GET_MY_TDS = 'GET_MY_TDS';
export const getMyTDSs = createAction(GET_MY_TDS);

export const VERIFY_PROMO_CODE = 'VERIFY_PROMO_CODE';
export const verifyPromoCode = createAction(VERIFY_PROMO_CODE);

export const GET_ALL_VERIFICATION_STATUS_LIST = 'GET_ALL_VERIFICATION_STATUS_LIST';
export const getAllVerificationStatusList = createAction(GET_ALL_VERIFICATION_STATUS_LIST);

export const TRANSFER_FUND = 'TRANSFER_FUND';
export const transferfund = createAction(TRANSFER_FUND);

export const WITHDRAW_MONEY = 'WITHDRAW_MONEY';
export const withdrawMoney = createAction(WITHDRAW_MONEY);

export const WITHDRAW_TO_PAYTM_VIA_PAYTM_GATEWAY = 'WITHDRAW_TO_PAYTM_VIA_PAYTM_GATEWAY';
export const withdrawToPaytmViaPaytmGateway = createAction(WITHDRAW_TO_PAYTM_VIA_PAYTM_GATEWAY);

export const GET_PAYTM_TOKEN = 'GET_PAYTM_TOKEN';
export const getPaytmToken = createAction(GET_PAYTM_TOKEN);

export const GET_PAYTM_TOKEN_FOR_SDK = 'GET_PAYTM_TOKEN_FOR_SDK';
export const getPaytmTokenForSDK = createAction(GET_PAYTM_TOKEN_FOR_SDK);

export const GET_CASHFREE_TOKEN_SDK = 'GET_CASHFREE_TOKEN_SDK';
export const getCashfreeTokenSDK = createAction(GET_CASHFREE_TOKEN_SDK);

export const UPDATE_PAYTM_SDK_RESPONSE = 'UPDATE_PAYTM_SDK_RESPONSE';
export const updatePaytmSdkResponse = createAction(UPDATE_PAYTM_SDK_RESPONSE);

export const UPDATE_CASHFREE_SDK_RESPONSE = 'UPDATE_CASHFREE_SDK_RESPONSE';
export const updateCashfreeSdkResponse = createAction(UPDATE_CASHFREE_SDK_RESPONSE);

export const GET_TDS_DETAILS = 'GET_TDS_DETAILS';
export const getTDSdetails = createAction(GET_TDS_DETAILS);

export const ADD_PROMO_FOR_PAYTM = 'ADD_PROMO_FOR_PAYTM';
export const addPromoForPaytm = createAction(ADD_PROMO_FOR_PAYTM);

export const GET_BALANCES = 'GET_BALANCES';
export const getBalances = createAction(GET_BALANCES);

export const GET_USER_DEPOSIT_HISTORY = 'GET_USER_DEPOSIT_HISTORY';
export const getUserDepositHistory = createAction(GET_USER_DEPOSIT_HISTORY);

export const GET_GAME_TRANSACTION_HISTORY = 'GET_GAME_TRANSACTION_HISTORY';
export const getGameTransactionHistory = createAction(GET_GAME_TRANSACTION_HISTORY);

export const GET_POKER_TRANSACTION_HISTORY = 'GET_POKER_TRANSACTION_HISTORY';
export const getPokerTransactionsHistory = createAction(GET_POKER_TRANSACTION_HISTORY);

export const GET_WITHDRAWAL_HISTORY = 'GET_WITHDRAWAL_HISTORY';
export const getUserWithdrawalHistory = createAction(GET_WITHDRAWAL_HISTORY);

export const GET_PAYTM_DEPOSIT_STATUS = 'GET_PAYTM_DEPOSIT_STATUS';
export const getPaytmDepositStatus = createAction(GET_PAYTM_DEPOSIT_STATUS);

export const GET_CASHFREE_PAYMENT_URL = 'GET_CASHFREE_PAYMENT_URL';
export const getCashfreePaymentURL = createAction(GET_CASHFREE_PAYMENT_URL);

export const GET_BONUS_WALLET_EARNING_HISTORY = 'GET_BONUS_WALLET_EARNING_HISTORY';
export const getBonusWalletEarningHistory = createAction(GET_BONUS_WALLET_EARNING_HISTORY);

export const GET_PRIMARY_WALLET_EARNING_HISTORY = 'GET_PRIMARY_WALLET_EARNING_HISTORY';
export const getPrimaryWalletEarningHistory = createAction(GET_PRIMARY_WALLET_EARNING_HISTORY);

export const GET_WINNINGS_ADJUSTMENTS_LIST = 'GET_WINNINGS_ADJUSTMENTS_LIST';
export const getWinningsAdjustmentList = createAction(GET_WINNINGS_ADJUSTMENTS_LIST);

export const GET_PROMO_CODE_LIST = 'GET_PROMO_CODE_LIST';
export const getPromoCodeList = createAction(GET_PROMO_CODE_LIST);
